export default __webpack_public_path__ + "static/media/yr-radio-new.194cc7d7.svg";